/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntercomIdentityResponse
 */
export interface IntercomIdentityResponse {
    /**
     * The user id the hash was computed over — pass this same value to Intercom's login.
     * @type {string}
     * @memberof IntercomIdentityResponse
     */
    userId: string;
    /**
     * Hex-encoded HMAC-SHA256 of userId, keyed with the Intercom identity verification secret.
     * @type {string}
     * @memberof IntercomIdentityResponse
     */
    userHash: string;
}

/**
 * Check if a given object implements the IntercomIdentityResponse interface.
 */
export function instanceOfIntercomIdentityResponse(value: object): value is IntercomIdentityResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userHash' in value) || value['userHash'] === undefined) return false;
    return true;
}

export function IntercomIdentityResponseFromJSON(json: any): IntercomIdentityResponse {
    return IntercomIdentityResponseFromJSONTyped(json, false);
}

export function IntercomIdentityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntercomIdentityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'userHash': json['userHash'],
    };
}

  export function IntercomIdentityResponseToJSON(json: any): IntercomIdentityResponse {
      return IntercomIdentityResponseToJSONTyped(json, false);
  }

  export function IntercomIdentityResponseToJSONTyped(value?: IntercomIdentityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userHash': value['userHash'],
    };
}

